// Common nicknames, misspellings, concept queries mapped to canonical search terms.
const ETD_SYNONYMS = {
  // Bougainvillea nicknames + typos
  'bogan': 'bougainvillea', 'bogans': 'bougainvillea', 'bouganvilla': 'bougainvillea',
  'bouganvillea': 'bougainvillea', 'bouganville': 'bougainvillea', 'bouganvillia': 'bougainvillea',
  'bougenvilea': 'bougainvillea', 'bougenvillea': 'bougainvillea', 'bougenville': 'bougainvillea',
  'bougainvilea': 'bougainvillea', 'bougainvilla': 'bougainvillea', 'boganvillea': 'bougainvillea',
  // Concept queries - now map to tags we've added to relevant products
  'pest free': 'pest-free', 'pestfree': 'pest-free', 'no pest': 'pest-free', 'no pests': 'pest-free',
  'pest resistant': 'pest-resistant', 'pest proof': 'pest-free',
  'psyllid': 'psyllid-resistant', 'psyllid resistant': 'psyllid-resistant', 'psyllid free': 'psyllid-resistant',
  'no psyllid': 'psyllid-resistant', 'no psyllids': 'psyllid-resistant',
  'disease resistant': 'pest-resistant', 'disease free': 'pest-resistant',
  // Other concept queries
  'flower': 'flowering', 'flowers': 'flowering', 'flowering tree': 'flowering',
  'flowering trees': 'flowering', 'flowering plant': 'flowering', 'flowering plants': 'flowering',
  'blooms': 'flowering', 'blooming': 'flowering', 'bloom': 'flowering',
  'drought': 'drought tolerant', 'drought hardy': 'drought tolerant', 'dry climate': 'drought tolerant',
  'shade': 'shade tolerant', 'shady': 'shade tolerant', 'low light': 'shade tolerant',
  'low maintenance': 'low maintenance', 'low maintence': 'low maintenance', 'easy care': 'low maintenance',
  'no maintenance': 'low maintenance', 'hardy': 'hardy',
  'fast growing': 'fast growing', 'quick growing': 'fast growing', 'quick': 'fast growing',
  'evergreen': 'evergreen', 'all year': 'evergreen', 'year round': 'evergreen',
  'native': 'australian native', 'natives': 'australian native', 'australian': 'australian native',
  'coastal': 'coastal tolerant', 'beach': 'coastal tolerant', 'seaside': 'coastal tolerant',
  'frost': 'frost tolerant', 'cold tolerant': 'frost tolerant', 'cold climate': 'frost tolerant',
  'hot': 'drought tolerant', 'sunny': 'full sun', 'full sun': 'full sun',
  'wind': 'wind resistant', 'windy': 'wind resistant', 'exposed': 'wind resistant',
  'pool': 'poolside', 'pools': 'poolside', 'pool tree': 'poolside', 'pool plants': 'poolside',
  'shade tree': 'shade tree', 'screening': 'screening', 'privacy': 'screening',
  'privacy tree': 'screening', 'privacy hedge': 'hedging', 'hedge': 'hedging',
  'hedging': 'hedging', 'border': 'hedging', 'fence': 'screening',
  // Common names → botanical
  'bay tree': 'laurus', 'bay trees': 'laurus', 'bay': 'laurus',
  'pin oak': 'quercus palustris', 'english oak': 'quercus robur', 'red oak': 'quercus rubra',
  'crepe myrtle': 'lagerstroemia', 'crape myrtle': 'lagerstroemia', 'crepemyrtle': 'lagerstroemia',
  'silver birch': 'betula pendula', 'silver birches': 'betula pendula',
  'weeping willow': 'salix babylonica',
  'chinese elm': 'ulmus parvifolia', 'english elm': 'ulmus procera', 'golden elm': 'ulmus glabra lutescens',
  'bottlebrush': 'callistemon', 'bottle brush': 'callistemon',
  'frangipani': 'plumeria', 'native frangipani': 'hymenosporum',
  'water gum': 'tristaniopsis', 'watergum': 'tristaniopsis',
  'bottle tree': 'brachychiton', 'kurrajong': 'brachychiton',
  'silk tree': 'albizia', 'persian silk tree': 'albizia',
  'weeping fig': 'ficus', 'fig': 'ficus',
  'flowering gum': 'corymbia ficifolia', 'red flowering gum': 'corymbia ficifolia',
  'spotted gum': 'corymbia maculata', 'lemon scented gum': 'corymbia citriodora',
  'silver dollar gum': 'eucalyptus cinerea', 'snow gum': 'eucalyptus pauciflora',
  'river red gum': 'eucalyptus camaldulensis', 'argyle apple': 'eucalyptus cinerea',
  'lilly pilly': 'syzygium', 'lillypilly': 'syzygium',
  'lillypillies': 'syzygium', 'lilly pillies': 'syzygium',
  'ornamental pear': 'pyrus', 'snow pear': 'pyrus nivalis', 'manchurian pear': 'pyrus ussuriensis',
  'crab apple': 'malus', 'crabapple': 'malus', 'flowering crab': 'malus',
  'japanese maple': 'acer palmatum', 'red maple': 'acer rubrum',
  'canadian maple': 'acer rubrum', 'sugar maple': 'acer saccharum',
  'japanese box': 'buxus japonica', 'english box': 'buxus sempervirens',
  'box hedge': 'buxus', 'box': 'buxus',
  'paperbark': 'melaleuca', 'snow in summer': 'melaleuca linariifolia',
  'tea tree': 'leptospermum',
  'maidenhair tree': 'ginkgo', 'ginko': 'ginkgo', 'gingko': 'ginkgo',
  'london plane': 'platanus', 'plane tree': 'platanus',
  'liquid amber': 'liquidambar', 'liquidamber': 'liquidambar', 'sweetgum': 'liquidambar',
  'pencil pine': 'cupressus sempervirens glauca', 'leighton green': 'cupressus leylandii leighton',
  'better green': 'cupressus leylandii better', 'leyland cypress': 'cupressus leylandii',
  'portuguese laurel': 'prunus lusitanica',
  'magnolia teddy bear': 'magnolia grandiflora teddy bear', 'teddy bear': 'magnolia teddy bear',
  'little gem': 'magnolia little gem', 'kay parris': 'magnolia kay parris',
  'coast banksia': 'banksia integrifolia', 'coastal banksia': 'banksia integrifolia',
  'birthday candles': 'banksia spinulosa',
  'wattle': 'acacia', 'wattles': 'acacia',
  'pin oak tree': 'quercus palustris', 'pencil pines': 'cupressus sempervirens',
  'jacaranda': 'jacaranda', 'jacarander': 'jacaranda', 'jacarandas': 'jacaranda',
  'olive tree': 'olea', 'olive trees': 'olea', 'olives': 'olea',
  'apple tree': 'malus domestica', 'pear tree': 'pyrus', 'plum tree': 'prunus',
  'cherry tree': 'prunus', 'peach tree': 'prunus persica', 'pomegranate': 'punica',
  'orange jasmine': 'murraya', 'star jasmine': 'trachelospermum',
  'magnolia': 'magnolia', 'magnolias': 'magnolia',
  'maple': 'acer', 'maples': 'acer', 'birch': 'betula', 'birches': 'betula',
  'oak': 'quercus', 'oaks': 'quercus', 'cherry': 'prunus', 'plum': 'prunus',
  'peach': 'prunus persica', 'gum tree': 'eucalyptus', 'gum trees': 'eucalyptus',
  'gums': 'eucalyptus', 'banksia': 'banksia', 'banksias': 'banksia',
};

function etdRewriteQuery(query) {
  if (!query) return query;
  const trimmed = query.trim().toLowerCase();
  if (!trimmed) return query;
  if (ETD_SYNONYMS[trimmed]) return ETD_SYNONYMS[trimmed];
  if (trimmed.length >= 4) {
    for (const key in ETD_SYNONYMS) {
      if (key.length > trimmed.length && key.startsWith(trimmed)) {
        return ETD_SYNONYMS[key];
      }
    }
  }
  return query;
}

class PredictiveSearch extends HTMLFormElement {
  constructor() {
    super();
    this.cachedMap = new Map();
    this.focusElement = this.input;
    this.resetButton.addEventListener('click', this.clear.bind(this));
    this.input.addEventListener('input', FoxTheme.utils.debounce(this.onChange.bind(this), 300));
    this.input.addEventListener('focus', this.onFocus.bind(this));
    this.searchContent = this.querySelector('.search__content');
    this.searchRecommendationEmpty = this.dataset.searchRecommendationEmpty === 'true';
    const isTemplateSearch = this.closest('.template-search');
    if (isTemplateSearch) {
      document.addEventListener('click', this.handleClickOutside.bind(this));
    }
  }
  get input() { return this.querySelector('input[type="search"]'); }
  get resetButton() { return this.querySelector('button[type="reset"]'); }
  onFocus(event) {
    if (this.closest('.template-search')) {
      document.body.classList.add('predictive-search-open');
      if (this.getQuery().length === 0) return;
      this.runSearch();
    }
  }
  getQuery() { return this.input.value.trim(); }
  getSearchQuery() { return etdRewriteQuery(this.getQuery()); }
  clear(event = null) {
    event && event.preventDefault();
    if (this.searchRecommendationEmpty && this.searchContent) this.searchContent.classList.add('hidden');
    this.input.value = '';
    this.input.focus();
    this.removeAttribute('results');
  }
  setupURL() {
    const url = new URL(`${window.shopUrl}${FoxTheme.routes.predictive_search_url}`);
    const limit = parseInt(this.dataset.resultsLimit, 10) || 8;
    url.searchParams.set('q', this.getSearchQuery());
    url.searchParams.set('resources[type]', 'product,article,collection,query');
    url.searchParams.set('resources[limit]', limit);
    url.searchParams.set('resources[limit_scope]', 'each');
    url.searchParams.set('resources[options][prefix]', 'last');
    url.searchParams.set('resources[options][unavailable_products]', 'last');
    url.searchParams.set('resources[options][fields]', 'title,product_type,vendor,tag');
    url.searchParams.set('section_id', FoxTheme.utils.getSectionId(this));
    return url;
  }
  onChange() {
    if (this.getQuery().length === 0) { this.clear(); return; }
    this.runSearch();
  }
  runSearch() {
    const url = this.setupURL().toString();
    this.renderSection(url);
  }
  renderSection(url) {
    this.cachedMap.has(url) ? this.renderSectionFromCache(url) : this.renderSectionFromFetch(url);
  }
  renderSectionFromCache(url) {
    const responseText = this.cachedMap.get(url);
    this.renderSearchResults(responseText);
    this.setAttribute('results', '');
  }
  renderSectionFromFetch(url) {
    this.setAttribute('loading', 'true');
    this.resetButton.classList.add('btn--loading');
    fetch(url)
      .then((r) => { if (!r.ok) throw new Error('Network error'); return r.text(); })
      .then((responseText) => {
        this.renderSearchResults(responseText);
        this.cachedMap.set(url, responseText);
      })
      .catch((error) => {
        console.error('Search error: ', error);
        this.setAttribute('error', 'Failed to load data');
      })
      .finally(() => {
        this.removeAttribute('loading');
        this.resetButton.classList.remove('btn--loading');
        this.setAttribute('results', 'true');
      });
  }
  renderSearchResults(responseText) {
    const id = 'PredictiveSearchResults-' + FoxTheme.utils.getSectionId(this);
    const targetElement = document.getElementById(id);
    if (targetElement) {
      const parser = new DOMParser();
      const parsedDoc = parser.parseFromString(responseText, 'text/html');
      const contentElement = parsedDoc.getElementById(id);
      if (contentElement) {
        this.searchContent?.classList.remove('hidden');
        targetElement.innerHTML = contentElement.innerHTML;
      } else { console.error(`Element with id '${id}' not found in response.`); }
    } else { console.error(`Element with id '${id}' not found in document.`); }
  }
  handleClickOutside(event) {
    if (!this.contains(event.target)) {
      setTimeout(() => { document.body.classList.remove('predictive-search-open'); });
    }
  }
}
customElements.define('predictive-search', PredictiveSearch, { extends: 'form' });
class SearchDrawer extends DrawerComponent {
  constructor() { super(); }
  get requiresBodyAppended() { return false; }
  get input() { return this.querySelector('input[type="search"]'); }
  get focusElement() { return this.querySelector('input[type="search"]'); }
}
customElements.define('search-drawer', SearchDrawer);
document.addEventListener('submit', function (e) {
  const form = e.target;
  if (!form.matches('form[action*="/search"], form[is="predictive-search"]')) return;
  const input = form.querySelector('input[name="q"]');
  if (!input) return;
  const raw = input.value.trim();
  const rewritten = etdRewriteQuery(raw);
  if (rewritten !== raw) input.value = rewritten;
});
